import { useMemo } from 'react';
import { useAppContainerContext } from '../AppContainerContext';
import { SiestaAction } from '../types';

type SiestaActionsConfig = {
  [pageType: string]: SiestaAction[];
};

const SIESTA_ACTIONS_CONFIG: SiestaActionsConfig = {
  'suitability-report-edit': [
    { id: 'shorten', label: 'Make the document shorter' },
    { id: 'simplify', label: 'Simplify technical language and improve readability' },
    { id: 'summary', label: 'Add a concise executive summary at the top' },
  ],
  default: [
    { id: 'summarize', label: 'Summarize key information' },
    { id: 'improve', label: 'Suggest improvements' },
    { id: 'check', label: 'Check for errors' },
  ],
};

export function useSuggestedActions(): SiestaAction[] {
  const { contentMeta } = useAppContainerContext();
  const pageType = contentMeta?.pageType;

  return useMemo(() => {
    if (pageType && SIESTA_ACTIONS_CONFIG[pageType]) {
      return SIESTA_ACTIONS_CONFIG[pageType];
    }
    return SIESTA_ACTIONS_CONFIG.default;
  }, [pageType]);
}
